import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';
import { lastValueFrom } from 'rxjs';
import { ProductsService } from 'src/app/shared/service/product.service';
import * as Notiflix from 'notiflix';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router'; // Agregar Router
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Property } from 'grapesjs';
import { APIService } from 'src/app/shared/service/apiService.service';
import Swal from 'sweetalert2';

export interface nombreEbooks {
  name: string;
}

@Component({
  selector: 'app-new-ebook',
  templateUrl: './create-ebook.component.html',
  styleUrl: './create-ebook.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class CreateEbookComponent {
  public isEditMode: boolean = false; // Nueva propiedad para detectar modo edición
  public isButtonDisabled: boolean = true;
  @Input() ebookId;
  public ImgfileName = '';
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  public categorySelected = null;
  public levelSelected = null;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  public responseImgFile: string = '';
  public previewImg: any;
  public viewLoaderImg = false;
  public viewLoaderFile = false;
  public previewFile: any;
  file: File;
  public responseFile: string = '';
  imagesX: File[] = [];
  @Input() ebook!: any;
  @Input() requireAllFields: boolean = false;
  @Input() learning: any[] = [];
  @Input() target: any[] = [];
  @Input() newImageSelected: boolean = false;
  @Input() imgFileUrl: string = '';

  public categories = [];
  public levels = [];

  currentUser: any;
  step = 0; // Solo tendremos 2 steps: 0 (Contenido) y 1 (Ficha)
  isEbookInitialized = false;

  WEBURL = environment.WEBURL;
  slug: string = '';

  public ebookFiles: File[] = [];
  public responseEbookFile: string = '';
  public newEbookFileSelected: boolean = false;
  public EbookfileName = '';
  public previewEbookFile: any;
  public existingProductInfoId: number | null = null; // 🔥 Nueva propiedad

  public loadingEbook: boolean = false; // Spinner para cargar o editar ebook
  public loadingFicha: boolean = false; // Spinner para cargar la ficha

  constructor(
    private productService: ProductsService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute, // Inyectar ActivatedRoute
    private router: Router, // Inyectar Router
    private _formBuilder: FormBuilder, // Agregar FormBuilder
    private apiService: APIService // Agregar APIService
  ) {
    // 🔥 Cargar usuario actual PRIMERO desde localStorage
    this.loadUserDataFromLocalStorage();

    // 🔥 INICIALIZAR EBOOK VACÍO INMEDIATAMENTE para evitar errores de template
    this.ebook = {
      id: 0,
      TargetMarket: '',
      Objective: '',
      Introduction: '',
      CurrencyCode: 'MXN',
      product: [],
      Type: 'ebook',
      Family: 'ebooks',
      user_id: this.currentUser.id,
      category_id: 0,
      level_id: 0,
      teacher_id: this.currentUser.id,
      Title: '',
      Slug: 'https://www.learnify.com.mx/ebook/example',
      Category: null,
      SubCategory: null,
      Level: null,
      Language: 'Spanish',
      Active: true,
      UnitPrice: '0',
      Description: '',
      ImgFileUrl: '',
      EbookFileUrl: '',
      AccessType: 'Premium',
      CoursePct: "0.00"
    };

    // Inicializar FormGroups
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['']
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['']
    });
    // Detectar si estamos en modo edición
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.isEditMode = true;
        this.ebookId = params['id'];
      } else {
        this.isEditMode = false;
      }
      
      this.loadData();
    });
  }
  
  // Cargar datos del usuario desde localStorage (igual que el sidebar)
  loadUserDataFromLocalStorage() {
    try {
      const userData = localStorage.getItem('currentUser');
      this.currentUser = userData ? JSON.parse(userData) : { displayName: 'Usuario' };
      
      // Construir displayName si no existe
      if (!this.currentUser.displayName) {
        const firstName = this.currentUser.firstName?.trim();
        const lastName = this.currentUser.lastName?.trim();
        
        if (firstName && lastName) {
          this.currentUser.displayName = `${firstName} ${lastName}`;
        } else if (firstName) {
          this.currentUser.displayName = firstName;
        } else if (lastName) {
          this.currentUser.displayName = lastName;
        } else if (this.currentUser.email) {
          this.currentUser.displayName = this.currentUser.email.split('@')[0];
        } else {
          this.currentUser.displayName = 'Usuario';
        }
      }
      
      // Cargar imagen de perfil (igual que el sidebar)
      // Primero intentar con sessionStorage (donde se guarda el base64)
      const cachedBase64 = sessionStorage.getItem('profileImageBase64');
      if (cachedBase64 && cachedBase64.startsWith('data:')) {
        this.currentUser.imgProfile = cachedBase64;
      }
      // Si no hay en sessionStorage, verificar otras opciones
      else if (!this.currentUser?.imgProfile || !this.isValidImageUrl(this.currentUser.imgProfile)) {
        // Intentar con profileFileUrl
        if (this.currentUser?.profileFileUrl && this.isValidImageUrl(this.currentUser.profileFileUrl)) {
          this.currentUser.imgProfile = this.currentUser.profileFileUrl;
        }
        // Si no hay nada, usar imagen por defecto
        else {
          this.currentUser.imgProfile = 'assets/images/user.png';
        }
      }
      
      // Ahora cargar perfil actualizado de la API
      this.loadProfileFromAPI();
      
    } catch (error) {
      console.error('❌ Error al cargar datos del usuario desde localStorage:', error);
      this.currentUser = { displayName: 'Usuario', imgProfile: 'assets/images/user.png' };
    }
  }
  
  // Cargar perfil desde la API (igual que el sidebar)
  loadProfileFromAPI() {
    this.apiService.getProfile().subscribe({
      next: (response: any) => {
        if (response && response.success) {
          const userData = response.data;
          
          // Construir displayName
          const firstName = userData.firstName?.trim();
          const lastName = userData.lastName?.trim();
          
          if (firstName && lastName) {
            userData.displayName = `${firstName} ${lastName}`;
          } else if (firstName) {
            userData.displayName = firstName;
          } else if (lastName) {
            userData.displayName = lastName;
          } else if (userData.email) {
            userData.displayName = userData.email.split('@')[0];
          } else {
            userData.displayName = 'Usuario';
          }
          
          // Construir imagen con prioridad: base64 > profileFileUrl
          let imageUrl = '';
          if (userData.profileImage?.base64) {
            imageUrl = `data:image/jpeg;base64,${userData.profileImage.base64}`;
          } else if (userData.profileFileUrl && this.isValidImageUrl(userData.profileFileUrl)) {
            imageUrl = userData.profileFileUrl;
          } else {
            imageUrl = 'assets/images/user.png';
          }
          
          // Actualizar currentUser en memoria
          this.currentUser = {
            ...this.currentUser,
            ...userData,
            imgProfile: imageUrl
          };
          
          // Guardar imagen base64 en sessionStorage
          if (imageUrl?.startsWith('data:')) {
            try {
              sessionStorage.setItem('profileImageBase64', imageUrl);
            } catch (e) {
              console.warn('⚠️ No se pudo guardar imagen en sessionStorage:', e);
            }
          }
          
          console.log('✅ Perfil cargado desde la API:', this.currentUser.displayName);
        }
      },
      error: (error) => {
        console.error('❌ Error al cargar perfil desde la API:', error);
        // Mantener datos de localStorage si falla la API
      }
    });
  }
  
  // Validar si una URL de imagen es válida
  isValidImageUrl(url: string): boolean {
    if (!url) return false;
    if (url.startsWith('data:image')) return true;
    if (url.startsWith('http://') || url.startsWith('https://')) return true;
    if (url.startsWith('assets/')) return true;
    return false;
  }
  
  // Manejador de errores para imagen de perfil
  handleProfileImageError(event: any) {
    console.warn('❌ Error al cargar imagen de perfil del usuario, usando placeholder');
    event.target.src = 'assets/images/user.png';
    // Actualizar currentUser para que no intente cargar la imagen fallida de nuevo
    if (this.currentUser) {
      this.currentUser.imgProfile = 'assets/images/user.png';
    }
  }

  // Manejador de errores para imagen de portada del ebook
  handleImageError(event: any) {
    console.warn('❌ Error al cargar imagen de portada del ebook, usando placeholder');
    event.target.src = 'assets/images/placeholder.png';
  }

  // Método para obtener la vista previa de la imagen
  getImagePreview(): string | null {
    // Prioridad: previewImg (imagen seleccionada) > responseImgFile (imagen guardada)
    if (this.previewImg) {
      return this.previewImg;
    }
    if (this.responseImgFile) {
      return this.responseImgFile;
    }
    return null;
  }

  // Agregar propiedades:
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  // Modificar el método checkButtonState para incluir el archivo del ebook:
  checkButtonState() {
    if (this.step === 0) {
      // Step 0 (Contenido): Requiere título Y archivo PDF
      this.isButtonDisabled = !(
        this.ebook.Title && 
        this.ebook.Title.trim().length > 0 &&
        this.ebookFiles && 
        this.ebookFiles.length > 0
      );
    } else if (this.step === 1) {
      // Step 1 (Ficha): Requiere todos los campos si requireAllFields es true
      if (this.requireAllFields) {
        this.isButtonDisabled = !(
          this.ebook.Title &&
          this.ebook.Description &&
          this.ebook.ImgFileUrl &&
          typeof this.ebook.UnitPrice === 'number' || this.ebook.UnitPrice === '0' || this.ebook.UnitPrice === 0 && // Permitir precio 0
          this.ebook.Category &&
          this.ebook.Level &&
          this.learning.length > 0 &&
          this.target.length > 0 &&
          (this.responseEbookFile || this.ebookFiles.length > 0) // Requiere archivo del ebook
        );
      } else {
        this.isButtonDisabled = !(this.ebook.Title && this.ebook.Title.trim().length > 0);
      }
    }
  }

  
 // 🆕 NUEVO: Solo almacenar el archivo localmente (la nueva API lo subirá)
  onSelectEbookFiles(event) {
    this.ebookFiles = [];
    this.ebookFiles.push(...event.addedFiles);
    const file = this.ebookFiles[0];
    
    if (file) {
      // Validar tipo de archivo
      if (file.type !== 'application/pdf') {
        Notiflix.Notify.failure('❌ Solo se permiten archivos PDF');
        this.ebookFiles = [];
        return;
      }

      // Validar tamaño (máx 20MB)
      const maxSize = 20 * 1024 * 1024; // 20MB
      if (file.size > maxSize) {
        Notiflix.Notify.failure('❌ El archivo es demasiado grande (máx 20MB)');
        this.ebookFiles = [];
        return;
      }

      // Solo marcar como seleccionado y guardar nombre
      this.newEbookFileSelected = true;
      this.EbookfileName = file.name;
      
      Notiflix.Notify.success(`✅ Archivo "${file.name}" seleccionado`);
      console.log('📄 Archivo PDF seleccionado:', file.name, `(${(file.size / 1024 / 1024).toFixed(2)} MB)`);
      
      this.checkButtonState();
    }
  }

  // Agregar método auxiliar para obtener la extensión del archivo
  getFileExtension(filename: string): string {
    const extension = filename.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'epub':
        return 'application/epub+zip';
      case 'pdf':
        return 'application/pdf';
      case 'mobi':
        return 'application/x-mobipocket-ebook';
      case 'azw':
        return 'application/vnd.amazon.ebook';
      default:
        return 'application/octet-stream';
    }
  }

  // Agregar método para remover archivos del ebook:
  removeEbookFile(file: File) {
    this.ebookFiles = this.ebookFiles.filter(f => f !== file);

    if (this.ebookFiles.length === 0) {
      this.newEbookFileSelected = false;
      this.ebook.EbookFileUrl = '';
      this.responseEbookFile = '';
    }
    this.checkButtonState();
  }

  // Modificar removeExistingEbookFile:
  removeExistingEbookFile() {
    this.ebook.EbookFileUrl = null;
    this.newEbookFileSelected = false;
    this.responseEbookFile = null;
    this.EbookfileName = '';
    // 🔥 No limpiar existingProductInfoId para mantener la referencia
    this.checkButtonState();
  }

  removeTarget(fruit: any): void {
    const index = this.target.indexOf(fruit);
    if (index >= 0) {
      this.target.splice(index, 1);
    }
    this.checkButtonState();
  }

  // Modificar nextStep para crear el ebook en la API cuando avanza del paso 0 al 1
  async nextStep() {

    this.checkButtonState();

    if (this.isButtonDisabled) {
      Notiflix.Notify.warning('Por favor complete todos los campos requeridos.');
      return;
    }

    if (this.step === 0) {
      // En modo creación, solo avanzar al siguiente paso sin guardar
      // En modo edición, también solo avanzar
      // El guardado se hará en el paso 1 con los botones correspondientes
      
      this.step = 1;
      this.requireAllFields = true;
      this.checkButtonState();
    }
  }

  // El método initializeEbook original ya no es necesario, pero lo mantenemos por compatibilidad
  async initializeEbook() {
    if (!this.isEbookInitialized && !this.isEditMode) {
      await this.initializeNewEbook();
    }
  }

  saveEbook() {
    /* this.checkButtonState();

    if (this.isButtonDisabled) {
      Notiflix.Notify.warning('Por favor complete todos los campos requeridos y suba una imagen.');
      return;
    } */

    const target = this.target.map((t: any) => { return t.name })
    const objetive = this.learning.map((t: any) => { return t.name })

    // ✅ Preparar datos con la estructura correcta de la API
    const ebookData = {
      Title: this.ebook.Title,
      Description: this.ebook.Description || '',
      UnitPrice: parseFloat(this.ebook.UnitPrice) || 0,
      CurrencyCode: this.ebook.CurrencyCode || 'MXN',
      Type: 'ebook',
      Category: this.ebook.Category,
      SubCategory: this.ebook.SubCategory,
      Level: this.ebook.Level,
      Language: this.ebook.Language || 'Spanish',
      Active: true,
      ImgFileUrl: this.ebook.ImgFileUrl || '',
      Objective: objetive.join(","),
      Introduction: this.ebook.Introduction || '',
      AccessType: this.ebook.AccessType || 'Premium',
      TargetMarket: target.join(","),
      Slug: this.ebook.Slug?.split("/").pop() || 'ebook-example',
      CoursePct: "50.00"
    };

    this.productService.updateCourse2(this.ebookId, ebookData).subscribe((data: any) => {
      Notiflix.Notify.success('Ebook guardado con éxito');
      this.notifyParent.emit(this.ebook);
    });
  }

  // Modificar saveEbook para redireccionar:
  saveEbook2() {
    const target = this.target.map((t: any) => { return t.name })
    const objetive = this.learning.map((t: any) => { return t.name })

    // ✅ Preparar datos con la estructura correcta de la API
    const ebookData = {
      Title: this.ebook.Title,
      Description: this.ebook.Description || '',
      UnitPrice: parseFloat(this.ebook.UnitPrice) || 0,
      CurrencyCode: this.ebook.CurrencyCode || 'MXN',
      Type: 'ebook',
      Category: this.ebook.Category,
      SubCategory: this.ebook.SubCategory,
      Level: this.ebook.Level,
      Language: this.ebook.Language || 'Spanish',
      Active: true,
      ImgFileUrl: this.ebook.ImgFileUrl || '',
      Objective: objetive.join(","),
      Introduction: this.ebook.Introduction || '',
      AccessType: this.ebook.AccessType || 'Premium',
      TargetMarket: target.join(","),
      Slug: this.ebook.Slug?.split("/").pop() || 'ebook-example',
      CoursePct: "50.00"
    };

    this.productService.updateCourse2(this.ebookId, ebookData).subscribe((data: any) => {
      Notiflix.Notify.success('Ebook guardado con éxito');
      this.notifyParent.emit(this.ebook);
      
      // Redireccionar a la lista de ebooks
      setTimeout(() => {
        this.router.navigate(['/products/ebooks']);
      }, 1500); // Esperar 1.5 segundos para que se vea el mensaje de éxito
    });
  }

  previousStep() {
    if (this.step > 0) {
      this.step--;
      this.requireAllFields = false; // En el step de contenido no requerimos todos los campos
      this.checkButtonState();
    }
  }

  addTarget(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      this.target.push({ name: value.trim() });
    }

    if (input) {
      input.value = '';
    }
    this.checkButtonState();
  }

  remove(fruit: any): void {
    const index = this.learning.indexOf(fruit);
    if (index >= 0) {
      this.learning.splice(index, 1);
    }
    this.checkButtonState();
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      this.learning.push({ name: value.trim() });
    }

    if (input) {
      input.value = '';
    }
    this.checkButtonState();
  }

  selectCategory(event) {
    this.categorySelected = this.categories.find(cat => cat.id === parseInt(event.target.value));
    this.checkButtonState();
  }

  selectLevel(event) {
    this.levelSelected = this.levels.find(cat => cat.id === parseInt(event.target.value));
    this.checkButtonState();
  }

  // Modificar loadData para mostrar spinner
  async loadData() {
    this.loadingEbook = true; // Mostrar spinner al cargar el ebook
    try {
      // currentUser ya está cargado en el constructor
      if (!this.currentUser) {
        this.currentUser = JSON.parse(localStorage['currentUser']);
      }
      
      let catalogs = this.productService.getCatalogsName('Category');
      this.categories = await lastValueFrom(catalogs);
      console.log('📋 Categorías cargadas desde /catalogs-data/Category:', this.categories);

      catalogs = this.productService.getCatalogsName('Level');
      this.levels = await lastValueFrom(catalogs);
      console.log('📋 Niveles cargados desde /catalogs-data/Level:', this.levels);

      if (this.isEditMode && this.ebookId) {
        // MODO EDICIÓN: Cargar datos existentes usando la nueva API
        const product = this.productService.getEbookById(this.ebookId);
        const productData = await lastValueFrom(product);
        const productInfo = productData;

        this.categorySelected = productInfo.Category ?? null;
        this.levelSelected = productInfo.Level ?? null;
        
        // 🔥 CARGAR IMAGEN EXISTENTE
        // Prioridad: frontImage.base64 > ImgFileUrl
        if (productInfo.frontImage?.base64) {
          const mimeType = productInfo.frontImage.mimetype || 'image/jpeg';
          this.responseImgFile = `data:${mimeType};base64,${productInfo.frontImage.base64}`;
          this.previewImg = this.responseImgFile;
        } else if (productInfo.ImgFileUrl) {
          this.responseImgFile = productInfo.ImgFileUrl;
          this.previewImg = productInfo.ImgFileUrl;
        }
        this.newImageSelected = false; // No hay nueva imagen seleccionada
        
        // 🔥 CARGAR ARCHIVO EXISTENTE DEL EBOOK
        if (productInfo.ProductInfo && productInfo.ProductInfo.length > 0) {
          const ebookFile = productInfo.ProductInfo[0]; // Primer archivo (el ebook)
          this.responseEbookFile = ebookFile.Value;
          this.EbookfileName = ebookFile.FileName;
          this.existingProductInfoId = ebookFile.id; // Guardar el ID para actualizar
          this.newEbookFileSelected = false; // No hay nuevo archivo seleccionado
        }
        
        this.ebook = {
          id: productInfo.id,
          Category: productInfo.Category || productInfo.category_id || null,
          SubCategory: productInfo.SubCategory || null,
          Level: productInfo.Level || productInfo.level_id || null,
          Language: productInfo.Language || 'Spanish',
          Title: productInfo.Title || '',
          Description: productInfo.Description || '',
          Introduction: productInfo.Introduction || '',
          UnitPrice: productInfo.UnitPrice || '0',
          CurrencyCode: productInfo.CurrencyCode || 'MXN',
          ImgFileUrl: productInfo.ImgFileUrl || '',
          EbookFileUrl: this.responseEbookFile, // Usar el archivo cargado
          Slug: productInfo.Slug || '',
          TargetMarket: productInfo.TargetMarket || '',
          Objective: productInfo.Objective || '',
          AccessType: productInfo.AccessType || 'Premium',
          product: [],
          Type: 'ebook',
          Family: 'ebooks',
          user_id: productInfo.user_id,
          category_id: productInfo.category_id,
          level_id: productInfo.level_id,
          teacher_id: productInfo.teacher_id,
          Active: productInfo.Active !== undefined ? productInfo.Active : true,
          CoursePct: productInfo.CoursePct || "0.00"
        };
        
        this.learning = productInfo ? productInfo.Objective ? productInfo.Objective.split(",").map((o: any) => { return { name: o } }) : [] : [];
        this.target = productInfo ? productInfo.TargetMarket ? productInfo.TargetMarket.split(",").map((o: any) => { return { name: o } }) : [] : [];
        this.slug = productInfo ? productInfo.Slug : 'example';
        this.isEbookInitialized = true;
        
      } else if (!this.isEditMode) {
        // MODO CREACIÓN: NO llamar a la API, solo preparar el objeto vacío
        // El objeto ya está inicializado en el constructor
        this.isEbookInitialized = true;
        this.slug = 'example';
        console.log('✅ Modo creación: Ebook inicializado localmente (sin llamada a API)');
      }
    } catch (error) {
      console.error('❌ Error al cargar datos:', error);
      Notiflix.Notify.failure('Error al cargar los catálogos');
    } finally {
      this.loadingEbook = false; // Ocultar spinner al finalizar
    }
  }

  // Nuevo método específico para inicializar ebooks nuevos
  async initializeNewEbook() {
    try {
      // Generar título temporal si no existe
      const tempTitle = this.ebook?.Title?.trim() || `Nuevo Ebook ${Date.now()}`;
      
      // ✅ Estructura correcta según la API
      const initData = {
        Title: tempTitle, // ✅ Campo requerido
        Description: this.ebook?.Description || 'Descripción del ebook',
        UnitPrice: this.ebook?.UnitPrice || 0,
        CurrencyCode: this.ebook?.CurrencyCode || 'MXN',
        Type: 'ebook',
        Category: this.ebook?.Category || null,
        SubCategory: this.ebook?.SubCategory || null,
        Level: this.ebook?.Level || null,
        Language: this.ebook?.Language || 'Spanish',
        Active: true,
        ImgFileUrl: this.ebook?.ImgFileUrl || '',
        Objective: this.ebook?.Objective || '',
        Introduction: this.ebook?.Introduction || '',
        AccessType: this.ebook?.AccessType || 'Premium',
        TargetMarket: this.ebook?.TargetMarket || ''
      };
      
      console.log('📤 Enviando datos de inicialización:', initData);
      const response = await lastValueFrom(this.productService.inicializarEbook(initData));
      console.log('✅ Respuesta de inicialización:', response);
      
      // Extraer el ID de la respuesta
      this.ebookId = response.id;
      
      // Actualizar ebook con los datos reales del servidor
      this.ebook = {
        id: response.id,
        TargetMarket: response.TargetMarket || '',
        Objective: response.Objective || '',
        CurrencyCode: response.CurrencyCode || 'MXN',
        product: [],
        Type: response.Type || 'ebook',
        Family: 'ebooks',
        user_id: this.currentUser.id,
        category_id: response.category_id || null,
        level_id: response.level_id || null,
        teacher_id: this.currentUser.id,
        Title: response.Title || tempTitle,
        Slug: response.Slug || 'https://www.learnify.com.mx/ebook/example',
        Category: response.Category || response.category_id || 0,
        SubCategory: response.SubCategory || 0,
        Level: response.Level || response.level_id || 0,
        Language: response.Language || 'Spanish',
        Active: response.Active !== undefined ? response.Active : true,
        UnitPrice: response.UnitPrice || '0',
        Description: response.Description || '',
        Introduction: response.Introduction || '',
        ImgFileUrl: response.ImgFileUrl || '',
        EbookFileUrl: response.EbookFileUrl || '',
        AccessType: response.AccessType || 'Premium',
        CoursePct: response.CoursePct || "0.00"
      };
      
      this.isEbookInitialized = true;
      this.slug = 'example';

      Notiflix.Notify.success('Ebook inicializado correctamente');
      
    } catch (error: any) {
      console.error('❌ Error al inicializar ebook:', error);
      
      // Manejo específico de errores
      if (error.status === 0) {
        Notiflix.Notify.warning('⚠️ No se puede conectar con el servidor. Verifica tu conexión.');
      } else if (error.status === 400) {
        Notiflix.Notify.failure('Error en los datos enviados (400)');
      } else if (error.status === 503) {
        Notiflix.Notify.warning('⚠️ El servidor está temporalmente no disponible (503)');
      } else {
        Notiflix.Notify.failure('Error al inicializar el ebook');
      }
      
      // No lanzar el error para no romper el flujo
      // throw error;
    }
  }

  // 🆕 NUEVO: Crear ebook con archivo PDF en una sola petición
  async crearEbookConArchivo() {
    try {
      // Validar que tenemos el archivo PDF
      if (!this.ebookFiles || this.ebookFiles.length === 0) {
        Notiflix.Notify.failure('❌ Debes seleccionar un archivo PDF para el ebook');
        return;
      }

      const pdfFile = this.ebookFiles[0];

      // Validar tipo de archivo
      if (pdfFile.type !== 'application/pdf') {
        Notiflix.Notify.failure('❌ Solo se permiten archivos PDF');
        return;
      }

      // Validar tamaño (máx 20MB)
      const maxSize = 20 * 1024 * 1024; // 20MB
      if (pdfFile.size > maxSize) {
        Notiflix.Notify.failure('❌ El archivo es demasiado grande (máx 20MB)');
        return;
      }

      // Preparar arrays de objetivos y mercado objetivo
      const target = this.target.map((t: any) => t.name).join(",");
      const objetive = this.learning.map((t: any) => t.name).join(",");

      // Construir FormData
      const formData = new FormData();
      
      // 🔥 ARCHIVO PDF (requerido)
      formData.append('pdf_file', pdfFile);
      
      // 🔥 IMAGEN DE PORTADA (opcional pero recomendado)
      if (this.file) {
        formData.append('img_file', this.file);
        console.log('📸 Agregando imagen de portada al FormData:', this.file.name);
      }
      
      // 🔥 CAMPOS REQUERIDOS
      formData.append('Title', this.ebook.Title?.trim() || `Nuevo Ebook ${Date.now()}`);
      formData.append('Description', this.ebook.Description || 'Descripción del ebook');
      formData.append('Type', 'ebook');
      formData.append('Language', this.ebook.Language || 'Spanish');
      formData.append('Active', this.ebook.Active ? 'true' : 'false');
      
      // 🔥 CAMPOS OPCIONALES (solo agregar si tienen valor)
      if (this.ebook.UnitPrice !== null && this.ebook.UnitPrice !== undefined) {
        formData.append('UnitPrice', String(this.ebook.UnitPrice));
      }
      if (this.ebook.DiscountPrice !== null && this.ebook.DiscountPrice !== undefined) {
        formData.append('DiscountPrice', String(this.ebook.DiscountPrice));
      }
      if (this.ebook.CurrencyCode) {
        formData.append('CurrencyCode', this.ebook.CurrencyCode);
      }
      
      // 🔥 CATEGORÍA Y NIVEL - Usar los nombres correctos según la API
      if (this.ebook.Category) {
        formData.append('category_id', String(this.ebook.Category));
        console.log('📋 category_id:', this.ebook.Category);
      }
      if (this.ebook.SubCategory) {
        formData.append('subcategory_id', String(this.ebook.SubCategory));
        console.log('📋 subcategory_id:', this.ebook.SubCategory);
      }
      if (this.ebook.Level) {
        formData.append('level_id', String(this.ebook.Level));
        console.log('📋 level_id:', this.ebook.Level);
      }
      
      if (objetive) {
        formData.append('Objective', objetive);
      }
      if (this.ebook.Introduction) {
        formData.append('Introduction', this.ebook.Introduction);
      }
      if (this.ebook.AccessType) {
        formData.append('AccessType', this.ebook.AccessType);
      }
      if (target) {
        formData.append('TargetMarket', target);
      }

      console.log('📤 Creando ebook con archivo PDF...');
      Notiflix.Loading.circle('Creando ebook...');

      // Llamar al nuevo método del servicio
      const response = await lastValueFrom(
        this.productService.crearEbookConArchivo(formData)
      );

      Notiflix.Loading.remove();
      
      console.log('✅ Respuesta de la API:', response);

      // Extraer datos de la respuesta
      this.ebookId = response.id;
      this.existingProductInfoId = response.FileId;
      this.responseEbookFile = response.file?.url || '';
      this.EbookfileName = response.FileName || pdfFile.name;
      
      // Extraer URL de la imagen de portada si fue subida
      if (response.img_file?.url) {
        this.responseImgFile = response.img_file.url;
        console.log('✅ Imagen de portada subida:', this.responseImgFile);
      }

      // Actualizar ebook con datos del servidor
      this.ebook = {
        ...this.ebook,
        id: response.id,
        Title: response.Title,
        Description: response.Description,
        UnitPrice: response.UnitPrice,
        CurrencyCode: response.CurrencyCode,
        Type: response.Type,
        Category: response.Category,
        SubCategory: response.SubCategory,
        Level: response.Level,
        Language: response.Language,
        Active: response.Active,
        ImgFileUrl: response.img_file?.url || response.ImgFileUrl || '',
        Objective: response.Objective,
        Introduction: response.Introduction,
        AccessType: response.AccessType,
        TargetMarket: response.TargetMarket,
        EbookFileUrl: this.responseEbookFile,
        Slug: response.Slug,
        CoursePct: response.CoursePct || "0.00"
      };

      this.isEbookInitialized = true;

      // Mensaje de éxito más descriptivo
      const successMessage = this.file 
        ? '✅ Ebook creado con éxito (PDF e imagen de portada subidos)' 
        : '✅ Ebook creado con éxito (PDF subido)';
      
      Notiflix.Notify.success(successMessage);

    } catch (error: any) {
      Notiflix.Loading.remove();
      console.error('❌ Error al crear ebook con archivo:', error);
      
      // Manejo específico de errores según la documentación
      if (error.status === 0) {
        Notiflix.Notify.warning('⚠️ No se puede conectar con el servidor. Verifica tu conexión.');
      } else if (error.status === 400) {
        const errorMessage = error.error?.message || 'Error en los datos enviados';
        Notiflix.Notify.failure(`❌ ${errorMessage}`);
      } else if (error.status === 401) {
        Notiflix.Notify.failure('❌ No autorizado. Por favor inicia sesión nuevamente.');
      } else if (error.status === 413) {
        Notiflix.Notify.failure('❌ El archivo es demasiado grande (máx 20MB)');
      } else if (error.status === 415) {
        Notiflix.Notify.failure('❌ Tipo de archivo no soportado. Solo se permiten archivos PDF.');
      } else if (error.status === 503) {
        Notiflix.Notify.warning('⚠️ El servidor está temporalmente no disponible (503)');
      } else {
        Notiflix.Notify.failure('Error al crear el ebook');
      }
      
      throw error; // Lanzar el error para que el flujo no continúe
    }
  }

  // Modificado: Solo almacena la imagen localmente, sin subirla
  onSelectImages(event) {
    this.imagesX = [];
    this.imagesX.push(...event.addedFiles);
    this.file = this.imagesX[0];
    this.newImageSelected = true;

    if (this.file) {
      // Validar que sea una imagen
      if (!this.file.type.startsWith('image/')) {
        Notiflix.Notify.failure('❌ Solo se permiten archivos de imagen');
        this.removeImage(this.file);
        return;
      }

      // Validar tamaño (máx 5MB para imágenes)
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (this.file.size > maxSize) {
        Notiflix.Notify.failure('❌ La imagen es demasiado grande (máx 5MB)');
        this.removeImage(this.file);
        return;
      }

      console.log('📸 Imagen de portada seleccionada:', this.file.name);
      
      // Generar preview local
      this.viewBase64(this.file).then((image: any) => {
        this.previewImg = image.base; // Corregir: usar image.base en lugar de image
        console.log('✅ Preview generado correctamente');
      });

      this.ImgfileName = this.file.name;
      this.checkButtonState();
    }
  }

  removeImage(file: File) {
    this.imagesX = this.imagesX.filter(img => img !== file);

    if (this.imagesX.length === 0) {
      this.newImageSelected = false;
      this.ebook.ImgFileUrl = '';
      this.responseImgFile = '';
      this.previewImg = null; // Limpiar preview también
      this.file = null;
      console.log('🗑️ Imagen removida, preview limpiado');
    }
    this.checkButtonState();
  }

  removeExistingImage() {
    this.ebook.ImgFileUrl = null;
    this.newImageSelected = false;
    this.responseImgFile = null;
    this.previewImg = null; // Limpiar preview también
    console.log('🗑️ Imagen existente removida');
  }

  // Modificar generateSlug para más debug:
  generateSlug(event) {
    const value = event.target.value;
    const newString = value.toString().toLowerCase().replace(/[^A-Z0-9]/ig, "-");
    this.ebook.Slug = 'https://www.learnify.com.mx/ebook/' + newString;
    this.slug = newString;
  }

  viewBase64 = async ($event: any) => new Promise((resolve, reject) => {
    try {
      const unsafeImg = window.URL.createObjectURL($event);
      const image = this.sanitizer.bypassSecurityTrustUrl(unsafeImg);
      const reader = new FileReader();
      reader.readAsDataURL($event);
      reader.onload = () => {
        resolve({
          base: reader.result
        });
      };
      reader.onerror = error => {
        resolve({
          base: null
        });
      };
    } catch (e) {
      return null;
    }
  })

    // Método para manejar clicks en el stepper
  onStepperClick(stepIndex: number) {
    /* console.log('Click en step:', stepIndex); */
    
    // Solo permitir ir del step 1 al 0 (regreso)
    if (stepIndex === 0 && this.step === 1) {
      this.previousStep();
    }
    // No permitir ir del step 0 al 1 directamente
    else if (stepIndex === 1 && this.step === 0) {
      /* console.log('No se permite ir al step 1 sin completar el step 0'); */
      return;
    }
  }

  // Método para cancelar la creación del ebook
  cancelarEbook() {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán todos los cambios no guardados.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, cancelar',
      cancelButtonText: 'No, continuar editando'
    }).then((result) => {
      if (result.isConfirmed) {
        this.router.navigate(['/products/ebooks']);
      }
    });
  }

  // Método para crear o actualizar borrador según el modo
  async actualizarBorrador() {
    if (this.isEditMode) {
      // Modo edición: usar PUT
      await this.actualizarBorradorConPUT();
    } else {
      // Modo creación: usar POST
      await this.crearBorradorConPOST();
    }
  }

  // Método para crear el borrador usando POST (modo creación)
  async crearBorradorConPOST() {
    try {
      // Validar que haya archivo PDF
      if (!this.ebookFiles || this.ebookFiles.length === 0) {
        Notiflix.Notify.failure('❌ Debes seleccionar un archivo PDF para el ebook');
        return;
      }

      Notiflix.Loading.standard('Creando borrador...');

      // Usar el método existente crearEbookConArchivo que hace POST
      await this.crearEbookConArchivo();

      Notiflix.Loading.remove();
      Swal.fire({
        title: '¡Creado!',
        text: 'El borrador ha sido creado correctamente.',
        icon: 'success',
        confirmButtonText: 'Aceptar'
      }).then(() => {
        this.router.navigate(['/products/ebooks']);
      });
    } catch (error) {
      Notiflix.Loading.remove();
      console.error('Error al crear borrador:', error);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo crear el borrador.',
        icon: 'error',
        confirmButtonText: 'Aceptar'
      });
    }
  }

  // Método para actualizar el borrador usando PUT (modo edición)
  async actualizarBorradorConPUT() {
    try {
      if (!this.ebook.id) {
        Notiflix.Notify.failure('Error: No se encontró el ID del ebook');
        return;
      }

      Notiflix.Loading.standard('Actualizando borrador...');

      // Preparar FormData para la actualización
      const formData = new FormData();
      
      // 🔥 Si hay nueva imagen, agregarla
      if (this.file) {
        formData.append('img_file', this.file);
        console.log('📸 Agregando nueva imagen al FormData:', this.file.name);
      }
      
      // 🔥 Si hay nuevo PDF, agregarlo
      if (this.ebookFiles && this.ebookFiles.length > 0) {
        formData.append('pdf_file', this.ebookFiles[0]);
        console.log('📄 Agregando nuevo PDF al FormData:', this.ebookFiles[0].name);
      }
      
      // 🔥 Campos básicos (solo agregar si tienen valor)
      if (this.ebook.Title?.trim()) {
        formData.append('Title', this.ebook.Title.trim());
      }
      if (this.ebook.Description) {
        formData.append('Description', this.ebook.Description);
      }
      if (this.ebook.UnitPrice !== null && this.ebook.UnitPrice !== undefined) {
        formData.append('UnitPrice', String(this.ebook.UnitPrice));
      }
      if (this.ebook.CurrencyCode) {
        formData.append('CurrencyCode', this.ebook.CurrencyCode);
      }
      
      // 🔥 CATEGORÍA Y NIVEL - Usar los nombres correctos según la API
      if (this.ebook.Category) {
        formData.append('category_id', String(this.ebook.Category));
        console.log('📋 category_id:', this.ebook.Category);
      }
      if (this.ebook.SubCategory) {
        formData.append('subcategory_id', String(this.ebook.SubCategory));
      }
      if (this.ebook.Level) {
        formData.append('level_id', String(this.ebook.Level));
        console.log('📋 level_id:', this.ebook.Level);
      }
      
      if (this.ebook.Language) {
        formData.append('Language', this.ebook.Language);
      }
      if (this.ebook.AccessType) {
        formData.append('AccessType', this.ebook.AccessType);
      }
      if (this.ebook.Active !== undefined) {
        formData.append('Active', this.ebook.Active ? 'true' : 'false');
      }
      
      // Objetivos y mercado objetivo
      const objetive = this.learning.map(item => item.name).join(',');
      const target = this.target.map(item => item.name).join(',');
      
      if (objetive) {
        formData.append('Objective', objetive);
      }
      if (target) {
        formData.append('TargetMarket', target);
      }
      if (this.ebook.Introduction) {
        formData.append('Introduction', this.ebook.Introduction);
      }
      if (this.ebook.Slug) {
        formData.append('Slug', this.ebook.Slug);
      }

      console.log('📤 Actualizando ebook con FormData...');
      
      // Usar el método updateEbook2 con FormData
      await lastValueFrom(this.productService.updateEbook2(this.ebook.id, formData));

      Notiflix.Loading.remove();
      Swal.fire({
        title: '¡Actualizado!',
        text: 'El borrador ha sido actualizado correctamente.',
        icon: 'success',
        confirmButtonText: 'Aceptar'
      }).then(() => {
        this.router.navigate(['/products/ebooks']);
      });
    } catch (error) {
      Notiflix.Loading.remove();
      console.error('Error al actualizar borrador:', error);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo actualizar el borrador.',
        icon: 'error',
        confirmButtonText: 'Aceptar'
      });
    }
  }

  // Método para crear o actualizar y enviar a revisión según el modo
  async saveAndSendToReview() {
    if (this.isEditMode) {
      // Modo edición: usar PUT
      await this.actualizarYEnviarARevision();
    } else {
      // Modo creación: usar POST primero
      await this.crearYEnviarARevision();
    }
  }

  // Método para crear y enviar a revisión (modo creación)
  async crearYEnviarARevision() {
    try {
      // Validar que haya archivo PDF
      if (!this.ebookFiles || this.ebookFiles.length === 0) {
        Notiflix.Notify.failure('❌ Debes seleccionar un archivo PDF para el ebook');
        return;
      }

      Notiflix.Loading.standard('Creando y enviando a revisión...');

      // Primero crear el ebook con POST
      await this.crearEbookConArchivo();

      // Verificar que se haya creado correctamente
      if (!this.ebook.id) {
        Notiflix.Loading.remove();
        Notiflix.Notify.failure('Error al crear el ebook');
        return;
      }

      // Luego enviar a revisión
      await lastValueFrom(this.productService.sendEbookToReview(this.ebook.id));

      Notiflix.Loading.remove();
      Swal.fire({
        title: '¡Enviado!',
        text: 'El ebook ha sido creado y enviado a revisión correctamente.',
        icon: 'success',
        confirmButtonText: 'Aceptar'
      }).then(() => {
        this.router.navigate(['/products/ebooks']);
      });
    } catch (error) {
      Notiflix.Loading.remove();
      console.error('Error al crear y enviar a revisión:', error);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo crear o enviar el ebook a revisión.',
        icon: 'error',
        confirmButtonText: 'Aceptar'
      });
    }
  }

  // Método para actualizar y enviar a revisión (modo edición)
  async actualizarYEnviarARevision() {
    try {
      if (!this.ebook.id) {
        Notiflix.Notify.failure('Error: No se encontró el ID del ebook');
        return;
      }

      Notiflix.Loading.standard('Actualizando y enviando a revisión...');
      
      // Preparar los datos del ebook
      const ebookData = {
        Title: this.ebook.Title,
        Description: this.ebook.Description,
        UnitPrice: this.ebook.UnitPrice,
        CurrencyCode: this.ebook.CurrencyCode,
        Category: this.ebook.Category,
        Level: this.ebook.Level,
        Language: this.ebook.Language,
        ImgFileUrl: this.ebook.ImgFileUrl || this.responseImgFile,
        EbookFileUrl: this.ebook.EbookFileUrl || this.responseEbookFile,
        Objective: this.learning.map(item => item.name).join(','),
        TargetMarket: this.target.map(item => item.name).join(','),
        Introduction: this.ebook.Introduction,
        Slug: this.ebook.Slug,
        AccessType: this.ebook.AccessType,
        Active: this.ebook.Active,
        Type: 'ebook',
        Family: 'ebooks'
      };

      // Primero actualizar el ebook
      await lastValueFrom(this.productService.updateEbook2(this.ebook.id, ebookData));

      // Luego enviar a revisión
      await lastValueFrom(this.productService.sendEbookToReview(this.ebook.id));
      
      Notiflix.Loading.remove();
      Swal.fire({
        title: '¡Enviado!',
        text: 'El ebook ha sido actualizado y enviado a revisión correctamente.',
        icon: 'success',
        confirmButtonText: 'Aceptar'
      }).then(() => {
        this.router.navigate(['/products/ebooks']);
      });
    } catch (error) {
      Notiflix.Loading.remove();
      console.error('Error al actualizar y enviar a revisión:', error);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo actualizar o enviar el ebook a revisión.',
        icon: 'error',
        confirmButtonText: 'Aceptar'
      });
    }
  }

  // Método para enviar el ebook a revisión (desde la lista)
  async sendToReview() {
    try {
      if (!this.ebook.id) {
        Notiflix.Notify.failure('Primero debe guardar el ebook');
        return;
      }

      Notiflix.Loading.standard('Enviando a revisión...');
      
      await lastValueFrom(this.productService.sendEbookToReview(this.ebook.id));
      
      Notiflix.Loading.remove();
      Swal.fire({
        title: '¡Enviado!',
        text: 'El ebook ha sido enviado a revisión correctamente.',
        icon: 'success',
        confirmButtonText: 'Aceptar'
      }).then(() => {
        this.router.navigate(['/products/ebooks']);
      });
    } catch (error) {
      Notiflix.Loading.remove();
      console.error('Error al enviar a revisión:', error);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo enviar el ebook a revisión.',
        icon: 'error',
        confirmButtonText: 'Aceptar'
      });
    }
  }
}